export const isChinaPhone = function(phone) {
  return /^1\d{10}$/.test(phone);
};

export const isHKPhone = function(phone) {
  return /^\d{8}$/.test(phone);
};

export const isEmail = function(email) {
  return /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(email);
};

export const isIdCard = function(idCard) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(idCard);
};

export const verifyTradePassword = function(password) {
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/.test(password);
};
export const PhoneNum = function(phone){
	return /^[0-9_ -]*$/.test(phone)
};

export const Englist = function(name){
	return /^[A-Za-z0-9_ ]*$/.test(name)
};
